/* eslint-disable */
"use strict";
import _ from "lodash";
import moment from "moment";
import configurazioni from "@/services/configurazioniService.js";

// TODO Generalizzare per n decimali

const numDecimali = 4;

function arrotonda(valore) {
  const fattore = Math.pow(10, numDecimali);
  return Math.round((valore + Number.EPSILON) * fattore) / fattore;
}

function getTotaleProdotti(r) {
  // attenzione alle note con valore
  let qta = 0;
  let prezzo = 0;
  for (let i = r.length - 1; i >= 0; i--) {
    let riga = r[i];
    if (
      ["prodotto", "reparto"].includes(riga.tipo) &&
      parseFloat(riga.quantita || 0) > 0
    ) {
      let sconto = 0;
      let abbuono = 0;
      if (riga.sconto) {
        sconto += parseFloat(riga.sconto.prezzo);
      }
      if (riga.abbuono) {
        abbuono += parseFloat(riga.abbuono.prezzo);
      }
      qta += parseFloat(riga.quantita);
      prezzo += parseFloat(riga.prezzo) + sconto + abbuono;
    }
  }
  return { qta, totale: prezzo };
}

function getScontiScontrino(r) {
  let scontoSub = 0;
  let maggiorazioniSub = 0;
  let locSub = 0;
  let item = r.find((x) => x.tipo === "scontoSub");
  scontoSub += item ? parseFloat(item.valore) : 0;
  locSub += item ? parseFloat(item.valore) : 0;

  item = r.find((x) => x.tipo === "abbuonoSub");
  scontoSub += item ? parseFloat(item.valore) : 0;
  locSub += item ? parseFloat(item.valore) : 0;

  item = r.find((x) => x.tipo === "arrotondaDifetto");
  scontoSub += item ? -parseFloat(item.valore) : 0;
  locSub += item ? parseFloat(item.valore) : 0;

  item = r.find((x) => x.tipo === "arrotondaEccesso");
  maggiorazioniSub += item ? parseFloat(item.valore) : 0;
  locSub += item ? parseFloat(item.valore) : 0;

  item = r.find((x) => x.tipo === "subtotale");
  let subtotale = item ? parseFloat(item.prezzo) : 0;
  if (subtotale === 0 && locSub !== 0) {
    subtotale = getTotaleProdotti(r).totale;
  }
  const abbuonoPerEuro = subtotale > 0 ? locSub / subtotale : 0;
  return { scontoSub, maggiorazioniSub, abbuonoPerEuro };
}

function getTotaleResi(resi) {
  let qta = 0;
  let prezzo = 0;
  for (let i = resi.length - 1; i >= 0; i--) {
    let righe = resi[i].righe;
    for (let k = 0; k < righe.length; k++) {
      let riga = righe[k];
      if (
        ["prodotto", "reparto"].includes(riga.tipo) &&
        parseFloat(riga.quantita || 0) < 0
      ) {
        let sconto = 0;
        let abbuono = 0;
        if (riga.sconto) {
          sconto += parseFloat(riga.sconto.prezzo);
        }
        if (riga.abbuono) {
          abbuono += parseFloat(riga.abbuono.prezzo);
        }
        qta -= parseFloat(riga.quantita);
        prezzo -= parseFloat(riga.prezzo) + sconto + abbuono;
      }
    }
  }
  return { qta, totale: prezzo };
}

function calcolaTotaliAliquote(totali, valori) {
  for (let v of valori) {
    totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {};
    let t = totali[`iva_${v.aliquota}`];
    t.imponibile = +((t.imponibile || 0) + v.imponibile).toFixed(numDecimali);
    const calcIva =
      v.aliquota !== 0 ? v.imponibile * (parseFloat(v.aliquota) / 100) : 0;
    t.iva = +((t.iva || 0) + calcIva).toFixed(numDecimali);
    t.importo = +((t.importo || 0) + v.imponibile + calcIva).toFixed(
      numDecimali
    );
    t.aliquota = String(v.aliquota); // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita;
    t.merce = t.imponibile;
    t.ivaOmaggi = 0;
    t.importoOmaggi = 0;
    t.aliquota = v.aliquota;

    totali["generale"] = totali["generale"] || {};
    let tg = totali["generale"];
    tg.imponibile = +((tg.imponibile || 0) + v.imponibile).toFixed(numDecimali);
    tg.iva = +((tg.iva || 0) + calcIva).toFixed(numDecimali);
    tg.importo = +((tg.importo || 0) + v.imponibile + calcIva).toFixed(
      numDecimali
    );
    tg.quantita = (tg.quantita || 0) + v.quantita;
    tg.nettoMerce = tg.imponibile;
    tg.totaleMerce = tg.imponibile;
    tg.speseDocumentate = 0;
  }
  return totali;
}

// TODO: Per la fatturazione riepilogativa non si deve rifare la somma delle righe ma prendere i totali delle singole DDT e sommarle !!

function calcolaTotaliAliquote_v2(
  totali,
  valori,
  spese,
  scontoInFattura,
  totaleMerce
) {
  const sconto = parseFloat(scontoInFattura || 0);
  const totImpo =
    _.sumBy(valori, (el) => {
      return el.importoNettoTotale;
    }) || 0;
  const speseNd = spese.filter((x) => !x.documentate);
  const speseD = spese.filter((x) => x.documentate);
  const totSpeseNd =
    _.sumBy(speseNd, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0;
  const totSpeseD =
    _.sumBy(speseD, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0;
  const cr = totaleMerce !== 0 ? totSpeseNd / totaleMerce : 1;
  // Lo sconto agisce sull'imponibile, ma devo ripartirlo in percentuale perchè le varie voci sono separate per aliquota
  const scontoPerc =
    totImpo !== 0 ? (totImpo - (totImpo - sconto)) / totImpo : 0;
  for (let v of valori) {
    /*     totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {}
    let t = totali[`iva_${v.aliquota}`] */
    totali[`iva_${v.codice}`] = totali[`iva_${v.codice}`] || {};
    let t = totali[`iva_${v.codice}`];
    let importoNetto = +(v.importoNettoTotale * (1 - scontoPerc)).toFixed(
      numDecimali
    );
    let importoOmaggi = +((v.omaggi || 0) * (1 - scontoPerc)).toFixed(
      numDecimali
    );
    t.merce = +((t.merce || 0) + importoNetto).toFixed(numDecimali);
    let speseAl = +(importoNetto * cr).toFixed(numDecimali);
    t.spese = +((t.spese || 0) + speseAl).toFixed(numDecimali);
    t.imponibile = +((t.imponibile || 0) + importoNetto + speseAl).toFixed(
      numDecimali
    );
    // t.iva = +((t.iva || 0) + v.iva).toFixed(numDecimali)
    let iva = arrotonda(
      (v.aliquota * (importoNetto + speseAl + importoOmaggi)) / 100
    );
    t.ivaCodice = v.codice; // #### 03.05.2024
    t.iva = +((t.iva || 0) + iva).toFixed(numDecimali);
    t.ivaOmaggi = +(
      (t.ivaOmaggi || 0) + arrotonda((v.aliquota * importoOmaggi) / 100)
    ).toFixed(numDecimali);
    t.importoOmaggi = +importoOmaggi.toFixed(numDecimali);
    // t.importo = +((t.importo || 0) + v.importoTotale).toFixed(numDecimali)
    t.importo = +((t.importo || 0) + (importoNetto + speseAl) + iva).toFixed(
      numDecimali
    );
    t.aliquota = String(v.aliquota); // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita;

    totali["generale"] = totali["generale"] || {};
    let tg = totali["generale"];
    tg.imponibile = +((tg.imponibile || 0) + (importoNetto + speseAl)).toFixed(
      numDecimali
    );
    // tg.nettoMerce = +((tg.nettoMerce || 0) + v.importoNettoTotale).toFixed(numDecimali)
    tg.nettoMerce = +((tg.nettoMerce || 0) + importoNetto).toFixed(numDecimali);
    tg.totaleMerce = +((tg.totaleMerce || 0) + v.importoNettoTotale).toFixed(
      numDecimali
    );
    tg.spese = +((tg.spese || 0) + speseAl).toFixed(numDecimali);
    tg.iva = +((tg.iva || 0) + iva).toFixed(numDecimali);
    tg.importo = +((tg.importo || 0) + (importoNetto + speseAl) + iva).toFixed(
      numDecimali
    );
    tg.quantita = (tg.quantita || 0) + v.quantita;
  }
  // ##### 03/05/2024
  if (totSpeseD > 0) {
    totali[`iva_N1`] = totali[`iva_N1`] || {};
    let t = totali[`iva_N1`];
    t.imponibile = +((t.imponibile || 0) + totSpeseD).toFixed(numDecimali);
    t.iva = 0;
    t.ivaOmaggi = 0;
    t.importo = t.imponibile;
    t.ivaCodice = "N1";
    t.aliquota = 0;
    t.quantita = 1;
    t.spese = +((t.spese || 0) + totSpeseD).toFixed(numDecimali);
    t.merce = t.merce || 0;
    totali.generale.spese = +(totali.generale.spese + t.spese).toFixed(
      numDecimali
    );
  }
  totali.generale.imponibile = +(
    totali.generale.imponibile + totSpeseD
  ).toFixed(numDecimali);

  totali.generale.importo = +(totali.generale.importo + totSpeseD).toFixed(
    numDecimali
  );
  totali.generale.speseDocumentate = +totSpeseD.toFixed(numDecimali);

  //TODO: Verificare. Inserico calcolo seguente per problemi di arrotondamento ricalcolo iva e totale da imponibile per ogni aliquota
  // Può essere evitato se si sommano i totali delle ddt
  // Tiene conto anche degli omaggi con rivalsa

  let totaleIva = 0;
  let totaleImporto = 0;

  for (let item of Object.keys(totali).filter((x) => x !== "generale")) {
    let al = totali[item];
    al.iva = +((al.imponibile * parseFloat(al.aliquota)) / 100).toFixed(
      numDecimali
    );
    totaleIva += al.iva + al.ivaOmaggi;
    al.importo = +(al.imponibile + al.iva + al.ivaOmaggi).toFixed(numDecimali);
    totaleImporto += al.importo;
  }
  totali.generale.iva = totaleIva;
  totali.generale.importo = +totaleImporto.toFixed(numDecimali);

  // #### 03/05/2024
  for (let item of Object.keys(totali).filter((x) => x !== "generale")) {
    let al = totali[item];
    al.imponibile = +al.imponibile.toFixed(2);
    al.importo = +al.importo.toFixed(2);
    al.iva = +al.iva.toFixed(2);
    al.merce = +al.merce.toFixed(2);
  }
  totali.generale.imponibile = +totali.generale.imponibile.toFixed(2);
  totali.generale.importo = +totali.generale.importo.toFixed(2);
  totali.generale.iva = +totali.generale.iva.toFixed(2);
  totali.generale.nettoMerce = +totali.generale.nettoMerce.toFixed(2);
  totali.generale.totaleMerce = +totali.generale.totaleMerce.toFixed(2);

  return totali;
}

function calcolaTotaliAliquoteSpese(
  totaliFattura,
  speseFattura,
  scontoInFattura
) {
  // totali['generale'] = totali['generale'] || {}
  const totaleImponibile = totaliFattura.generale.imponibile;
  let tg = {};
  const totali = _.omit(totaliFattura, "generale");
  const totaliAliquota = Object.values(totali);
  for (let t of totaliAliquota) {
    const { totaleSpese } = calcolaSpese(
      speseFattura,
      t.imponibile,
      totaleImponibile
    );
    t.imponibile += totaleSpese;
    t.spese = totaleSpese;
    // const calcIva = (t.aliquota !== 0) ? (t.imponibile * (parseFloat(t.aliquota) / 100)) : 0
    t.iva = +(t.aliquota !== 0
      ? t.imponibile * (parseFloat(t.aliquota) / 100)
      : 0
    ).toFixed(numDecimali);
    t.importo = +(t.imponibile + t.iva).toFixed(numDecimali);

    tg.imponibile = +((tg.imponibile || 0) + t.imponibile).toFixed(numDecimali);
    tg.iva = +((tg.iva || 0) + t.iva).toFixed(numDecimali);
    tg.importo = +((tg.importo || 0) + t.importo).toFixed(numDecimali);
    tg.quantita = (tg.quantita || 0) + t.quantita;
    tg.spese = (tg.spese || 0) + t.spese;
    tg.nettoMerce = tg.imponibile;
    tg.totaleMerce = tg.imponibile;
    tg.speseDocumentate = 0;
  }
  const totaleCompleto = { ...totali, generale: tg };
  return totaleCompleto;
}

function calcolaScadenze(totali, pagamento, splitPayment) {
  const totale = splitPayment ? totali.generale.imponibile : totali.generale.importo

  const scadenze = [];
  var scadenza;
  if (!pagamento) {
    scadenza = {
      data: moment().format("DD/MM/YYYY"),
      importo: +totale.toFixed(2),
    };
    scadenze.push(scadenza);
  } else {
    if (!pagamento.giorniPagamento) {
      if (!pagamento.dataPagamento || pagamento.dataPagamento === "DF") {
        scadenza = {
          data: moment().format("DD/MM/YYYY"),
          importo: +totale.toFixed(2),
        };
      } else {
        scadenza = {
          data: moment()
            .endOf("mounth")
            .format("DD/MM/YYYY"),
          importo: +totale.toFixed(2),
        };
      }
      scadenze.push(scadenza);
    } else {
      let numeroPagamenti = pagamento.giorniPagamento.length;
      let importoScadenza = +(
        totale / numeroPagamenti
      ).toFixed(numDecimali);
      let acc = 0;
      for (let i = 0; i < numeroPagamenti; i++) {
        if (i === numeroPagamenti - 1) {
          importoScadenza = +(totale - acc).toFixed(
            numDecimali
          );
        }
        acc += importoScadenza;
        importoScadenza = +importoScadenza.toFixed(2);
        let dataScadenza =
          pagamento.dataPagamento === "DF"
            ? moment().add(pagamento.giorniPagamento[i], "day")
            : moment()
                .add(pagamento.giorniPagamento[i], "day")
                .endOf("month");
        scadenza = {
          data: dataScadenza.format("DD/MM/YYYY"),
          importo: importoScadenza,
        };
        scadenze.push(scadenza);
      }
    }
  }
  return scadenze;
}

function calcolaSpese(speseFattura, importo, totale) {
  const spese = [];
  var valore;
  var totaleSpese = 0;
  for (let sp of speseFattura) {
    if (sp.tipo === "IMPORTO") {
      valore = +parseFloat(sp.valore).toFixed(numDecimali);
    }
    if (sp.tipo === "PERCENTUALE") {
      valore = +((parseFloat(sp.valore) * importo) / 100).toFixed(numDecimali);
    }
    totaleSpese += +((valore * importo) / totale).toFixed(numDecimali);
    spese.push({ descrizione: sp.descrizione, importo: valore });
  }
  return { spese, totaleSpese: +totaleSpese.toFixed(numDecimali) };
}

async function calcolaValoriScontrino_old(sc) {
  let totaliAliquote = {};
  let totaleComplessivo = 0;
  let totalePagato = 0;
  let contanti = 0;
  let cartaDiCredito = 0;
  let nonRiscosso = 0;
  let buoni = 0;
  let resi = 0;
  let scontoSub = 0;
  let maggiorazioniSub = 0;
  // TODO: Costruire in base agli effettivi reparti presenti nel database
  const elencoReparti = await configurazioni.getConfigurazione(
    "prodotti_reparti_fiscali",
    "reparti"
  );
  const aliquote = await configurazioni.getConfigurazione(
    "prodotti_aliquote_iva",
    "aliquote"
  );
  const repartiStatistica = elencoReparti.map((x) => {
    const iva = aliquote.find((i) => i.codice === x.codiceIva);
    return {
      repartoFiscale: parseInt(x.stampante.numero),
      tipoBene: x.descrizione,
      descrizione: `Iva ${x.stampante.posizioneIva}: ${iva.descrizione}`,
      aliquota: iva.aliquota,
    };
  });
  /*   const repartiStatistica = [
    { repartoFiscale: 1, tipoBene: 'Prodotti 22%', descrizione: 'Iva 1: 22%', aliquota: 22 },
    { repartoFiscale: 5, tipoBene: 'Servizi 22%', descrizione: 'Iva 5: 22%', aliquota: 5 },
    { repartoFiscale: 2, tipoBene: 'Prodotti 10%', descrizione: 'Iva 2: 10%', aliquota: 10 },
    { repartoFiscale: 3, tipoBene: 'Prodotti 4%', descrizione: 'Iva 3: 4%', aliquota: 4 },
    { repartoFiscale: 4, tipoBene: 'Prodotti 5%', descrizione: 'Iva 4: 5%', aliquota: 5 },
    { repartoFiscale: 6, tipoBene: 'Prodotti esenti', descrizione: 'Iva 6: N2', aliquota: 0 }
  ] */

  const r = sc.righe;
  let item = r.find((x) => x.tipo === "totalecomplessivo");
  totaleComplessivo += item ? parseFloat(item.prezzo) : 0;
  item = r.find((x) => x.tipo === "totale");
  totalePagato += item ? parseFloat(item.prezzo) : 0;
  if (!_.isEmpty(sc.pagamento)) {
    const resto = parseFloat(sc.pagamento.resto || 0);
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "contanti");
    contanti += (item ? parseFloat(item.importo) : 0) - resto;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "cartadicredito");
    cartaDiCredito += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "nonriscossobeni");
    nonRiscosso += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "nonriscosso");
    nonRiscosso += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "buonimultiuso");
    buoni += item ? parseFloat(item.importo) : 0;
  }
  if (sc.resi) {
    const resiScontrino = getTotaleResi(sc.resi);
    resi += resiScontrino.totale;
  }

  const scontiScontrino = getScontiScontrino(r);
  scontoSub += scontiScontrino.scontoSub;
  maggiorazioniSub += scontiScontrino.maggiorazioniSub;
  const abbuonoPerEuro = scontiScontrino.abbuonoPerEuro;

  for (let rp of repartiStatistica) {
    const qta = _.sumBy(
      r.filter(
        (x) =>
          x.repartoFiscale ===
          String(rp.repartoFiscale) /* && parseFloat(x.quantita || 0) > 0 */
      ),
      (el) => {
        return parseFloat(el.quantita);
      }
    );
    const vl = _.sumBy(
      r.filter(
        (x) =>
          x.repartoFiscale ===
          String(rp.repartoFiscale) /* && parseFloat(x.quantita || 0) > 0 */
      ),
      (el) => {
        return parseFloat(el.prezzo);
      }
    );

    let sconti = _.sumBy(
      r.filter(
        (x) =>
          x.repartoFiscale ===
          String(rp.repartoFiscale) /* && parseFloat(x.quantita || 0) > 0 */
      ),
      (el) => {
        let sconto = 0;
        let tst = el.sconto;
        sconto += tst ? +parseFloat(tst.valore) : 0;
        tst = el.abbuono;
        sconto += tst ? tst.valore : 0;
        return sconto;
      }
    );
    const prezzo = vl - sconti;
    sconti += abbuonoPerEuro * prezzo;

    const pz = +(vl - sconti).toFixed(numDecimali);
    const impo =
      rp.aliquota !== 0
        ? +(pz / (1 + rp.aliquota / 100)).toFixed(numDecimali)
        : pz;
    const iva = pz - impo;

    let tal = totaliAliquote[rp.repartoFiscale] || {};
    tal.quantita = (tal.quantita || 0) + qta;
    tal.valore = (tal.valore || 0) + vl;
    tal.imponibile = (tal.imponibile || 0) + impo;
    tal.iva = (tal.iva || 0) + iva;
    tal.sconti = (tal.sconti || 0) + sconti;
    totaliAliquote[rp.repartoFiscale] = tal;
  }
  const valori = [];
  for (let rp of repartiStatistica) {
    const el = totaliAliquote[rp.repartoFiscale];
    if (el && el.valore > 0) {
      let valore = {
        prezzo: +(el.valore - el.sconti).toFixed(numDecimali),
        quantita: el.quantita,
        sconto: +el.sconti.toFixed(numDecimali),
        valore: +el.valore.toFixed(numDecimali),
        imponibile: +el.imponibile.toFixed(numDecimali),
        iva: +el.iva.toFixed(numDecimali),
      };
      valore.prezzoUnitario = +(valore.valore / valore.quantita).toFixed(
        numDecimali
      );
      // valore.prezzoTotale = valore.valore
      valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(
        numDecimali
      );
      valore.prezzoNettoUnitario =
        rp.aliquota !== 0
          ? +(valore.prezzoUnitario / (1 + rp.aliquota / 100)).toFixed(
              numDecimali
            )
          : valore.prezzoUnitario;
      // valore.prezzoNettoTotale = rp.aliquota !== 0 ? +(valore.prezzoTotale / (1 + rp.aliquota / 100)).toFixed(6) : valore.prezzoTotale
      valore.prezzoNettoTotale = +(
        valore.prezzoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore.importoUnitario = +(valore.prezzo / valore.quantita).toFixed(
        numDecimali
      );
      // valore.importoTotale = valore.prezzo
      valore.importoTotale = +(
        valore.importoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore.importoNettoUnitario = +(
        valore.imponibile / valore.quantita
      ).toFixed(numDecimali);
      // valore.importoNettoTotale = valore.imponibile
      valore.importoNettoTotale = +(
        valore.importoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore = { ...valore, ...rp };
      valori.push(valore);
    }
  }
  return valori;
}

async function calcolaValoriScontrino(sc) {
  let totaliAliquote = {};
  let totaleComplessivo = 0;
  let totalePagato = 0;
  let contanti = 0;
  let cartaDiCredito = 0;
  let nonRiscosso = 0;
  let buoni = 0;
  let resi = 0;
  let scontoSub = 0;
  let maggiorazioniSub = 0;
  // TODO: Costruire in base agli effettivi reparti presenti nel database
  const elencoReparti = await configurazioni.getConfigurazione(
    "prodotti_reparti_fiscali",
    "reparti"
  );
  let aliquoteConf = await configurazioni.getConfigurazione(
    "prodotti_aliquote_iva",
    "aliquote"
  );
  let aliquote = aliquoteConf; // .map(x => _.omit(x, 'stampante'))
  for (let al of aliquote) {
    const repartoFiscale = elencoReparti.find(
      (x) => String(x.stampante.numero) === String(al.stampante.posizione)
    );
    al.tipoBene = repartoFiscale ? repartoFiscale.descrizione : al.descrizione;
  }
  aliquote = _.uniqBy(aliquote, "codice");

  const r = sc.righe;
  let item = r.find((x) => x.tipo === "totalecomplessivo");
  totaleComplessivo += item ? parseFloat(item.prezzo) : 0;
  item = r.find((x) => x.tipo === "totale");
  totalePagato += item ? parseFloat(item.prezzo) : 0;
  if (!_.isEmpty(sc.pagamento)) {
    const resto = parseFloat(sc.pagamento.resto || 0);
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "contanti");
    contanti += (item ? parseFloat(item.importo) : 0) - resto;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "cartadicredito");
    cartaDiCredito += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "nonriscossobeni");
    nonRiscosso += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "nonriscosso");
    nonRiscosso += item ? parseFloat(item.importo) : 0;
    item = sc.pagamento.pagamenti.find((x) => x.tipo === "buonimultiuso");
    buoni += item ? parseFloat(item.importo) : 0;
  }
  if (sc.resi) {
    const resiScontrino = getTotaleResi(sc.resi);
    resi += resiScontrino.totale;
  }

  const scontiScontrino = getScontiScontrino(r);
  scontoSub += scontiScontrino.scontoSub;
  maggiorazioniSub += scontiScontrino.maggiorazioniSub;
  const abbuonoPerEuro = scontiScontrino.abbuonoPerEuro;

  for (let al of aliquote) {
    // .filter(x => !_.isEmpty(x))
    const qta = _.sumBy(
      r.filter((x) => String(x.aliquota) === String(al.aliquota)),
      (el) => {
        return parseFloat(el.quantita || 0);
      }
    );
    const vl = _.sumBy(
      r.filter((x) => String(x.aliquota) === String(al.aliquota)),
      (el) => {
        return parseFloat(el.prezzo || 0);
      }
    );
    let sconti = _.sumBy(
      r.filter((x) => String(x.aliquota) === String(al.aliquota)),
      (el) => {
        let sconto = 0;
        let tst = el.sconto;
        sconto += tst ? +parseFloat(tst.valore) : 0;
        tst = el.abbuono;
        sconto += tst ? tst.valore : 0;
        return sconto;
      }
    );
    const prezzo = vl - sconti;
    sconti += abbuonoPerEuro * prezzo;

    const pz = +(vl - sconti).toFixed(numDecimali);
    const impo =
      al.aliquota !== 0
        ? +(pz / (1 + al.aliquota / 100)).toFixed(numDecimali)
        : pz;
    const iva = pz - impo;

    let tal = totaliAliquote[String(al.aliquota)] || {};
    tal.quantita = (tal.quantita || 0) + qta;
    tal.valore = (tal.valore || 0) + vl;
    tal.imponibile = (tal.imponibile || 0) + impo;
    tal.iva = (tal.iva || 0) + iva;
    tal.sconti = (tal.sconti || 0) + sconti;
    totaliAliquote[String(al.aliquota)] = tal;
  }

  const valori = [];
  for (let al of aliquote) {
    // .filter(x => !_.isEmpty(x))
    const el = totaliAliquote[String(al.aliquota)];
    if (el && el.valore > 0) {
      let valore = {
        prezzo: +(el.valore - el.sconti).toFixed(numDecimali),
        quantita: el.quantita,
        sconto: +el.sconti.toFixed(numDecimali),
        valore: +el.valore.toFixed(numDecimali),
        imponibile: +el.imponibile.toFixed(numDecimali),
        iva: +el.iva.toFixed(numDecimali),
      };
      valore.prezzoUnitario = +(valore.valore / valore.quantita).toFixed(
        numDecimali
      );
      // valore.prezzoTotale = valore.valore
      valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(
        numDecimali
      );
      valore.prezzoNettoUnitario =
        al.aliquota !== 0
          ? +(valore.prezzoUnitario / (1 + al.aliquota / 100)).toFixed(
              numDecimali
            )
          : valore.prezzoUnitario;
      // valore.prezzoNettoTotale = rp.aliquota !== 0 ? +(valore.prezzoTotale / (1 + rp.aliquota / 100)).toFixed(6) : valore.prezzoTotale
      valore.prezzoNettoTotale = +(
        valore.prezzoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore.importoUnitario = +(valore.prezzo / valore.quantita).toFixed(
        numDecimali
      );
      // valore.importoTotale = valore.prezzo
      valore.importoTotale = +(
        valore.importoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore.importoNettoUnitario = +(
        valore.imponibile / valore.quantita
      ).toFixed(numDecimali);
      // valore.importoNettoTotale = valore.imponibile
      valore.importoNettoTotale = +(
        valore.importoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore = { ...valore, ...al };
      valori.push(valore);
    }
  }
  return valori;

  // **************************************************************
  /*   const repartiStatistica = elencoReparti.map(x => {
    const iva = aliquote.find(i => i.codice === x.codiceIva)
    return {
      repartoFiscale: parseInt(x.stampante.numero),
      tipoBene: x.descrizione,
      descrizione: `Iva ${x.stampante.posizioneIva}: ${iva.descrizione}`,
      aliquota: iva.aliquota
    }
  })   */

  /* const valori = []
  for (let rp of repartiStatistica)  {
    const el = totaliAliquote[rp.repartoFiscale]
    if (el && el.valore > 0) {
      let valore = {
        prezzo: +(el.valore - el.sconti).toFixed(numDecimali),
        quantita: el.quantita,
        sconto: +el.sconti.toFixed(numDecimali),
        valore: +el.valore.toFixed(numDecimali),
        imponibile: +el.imponibile.toFixed(numDecimali),
        iva: +el.iva.toFixed(numDecimali)
      }
      valore.prezzoUnitario = +(valore.valore / valore.quantita).toFixed(numDecimali)
      // valore.prezzoTotale = valore.valore
      valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
      valore.prezzoNettoUnitario = rp.aliquota !== 0 ? +(valore.prezzoUnitario / (1 + rp.aliquota / 100)).toFixed(numDecimali) : valore.prezzoUnitario
      // valore.prezzoNettoTotale = rp.aliquota !== 0 ? +(valore.prezzoTotale / (1 + rp.aliquota / 100)).toFixed(6) : valore.prezzoTotale
      valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)
      valore.importoUnitario = +(valore.prezzo / valore.quantita).toFixed(numDecimali)
      // valore.importoTotale = valore.prezzo
      valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)
      valore.importoNettoUnitario = +(valore.imponibile / valore.quantita).toFixed(numDecimali)
      // valore.importoNettoTotale = valore.imponibile
      valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
      valore = { ...valore, ...rp }
      valori.push(valore)
    }
  }
  return valori */
}

async function calcolaDettaglioScontrino(sc) {
  // TODO: Costruire in base agli effettivi reparti presenti nel database
  const elencoReparti = await configurazioni.getConfigurazione(
    "prodotti_reparti_fiscali",
    "reparti"
  );
  const aliquote = await configurazioni.getConfigurazione(
    "prodotti_aliquote_iva",
    "aliquote"
  );

  const repartiStatistica = elencoReparti.map((x) => {
    const iva = aliquote.find((i) => i.codice === x.codiceIva);
    return {
      repartoFiscale: parseInt(x.stampante.numero),
      tipoBene: x.descrizione,
      descrizione: iva ? iva.descrizione : "",
      aliquota: iva ? iva.aliquota : 0,
      aliquotaIva: iva ? iva.codice : "",
    };
  });
  /*   const repartiStatistica = [
    { repartoFiscale: 1, tipoBene: 'Prodotti 22%', descrizione: 'Iva 1: 22%', aliquota: 22 },
    { repartoFiscale: 5, tipoBene: 'Servizi 22%', descrizione: 'Iva 5: 22%', aliquota: 5 },
    { repartoFiscale: 2, tipoBene: 'Prodotti 10%', descrizione: 'Iva 2: 10%', aliquota: 10 },
    { repartoFiscale: 3, tipoBene: 'Prodotti 4%', descrizione: 'Iva 3: 4%', aliquota: 4 },
    { repartoFiscale: 4, tipoBene: 'Prodotti 5%', descrizione: 'Iva 4: 5%', aliquota: 5 },
    { repartoFiscale: 6, tipoBene: 'Prodotti esenti', descrizione: 'Iva 6: N2', aliquota: 0 }
  ] */
  const righe = sc.righe;
  const scontiScontrino = getScontiScontrino(righe);
  const abbuonoPerEuro = scontiScontrino.abbuonoPerEuro;

  const valori = [];
  for (let i = righe.length - 1; i >= 0; i--) {
    let riga = righe[i];
    if (["descrizione"].includes(riga.tipo)) {
      let valoreC = {
        rigaDescrittiva: true,
        descrizione: riga.descrizione,
      };
      valori.push(valoreC);
    }
    if (
      ["prodotto", "reparto"].includes(riga.tipo) &&
      parseFloat(riga.quantita || 0) > 0
    ) {
      let sconto = 0;
      let abbuono = 0;
      if (riga.sconto) {
        sconto += parseFloat(riga.sconto.prezzo);
      }
      if (riga.abbuono) {
        abbuono += parseFloat(riga.abbuono.prezzo);
      }
      let qta = parseFloat(riga.quantita);
      let sconti = -(sconto + abbuono);
      let prezzo = parseFloat(riga.prezzo) - sconti;
      sconti += abbuonoPerEuro * prezzo;
      const pz = +(parseFloat(riga.prezzo) - sconti).toFixed(numDecimali);
      const reparto = riga.repartoFiscale;
      const rp = repartiStatistica.find(
        (x) => String(x.repartoFiscale) === reparto
      );
      const aliquota = rp.aliquota;
      const impo =
        aliquota !== 0 ? +(pz / (1 + aliquota / 100)).toFixed(numDecimali) : pz;
      const iva = pz - impo;
      let valore = {
        prezzo: +pz.toFixed(numDecimali),
        quantita: qta,
        sconto: +sconti.toFixed(numDecimali),
        valore: +parseFloat(riga.prezzo).toFixed(numDecimali),
        imponibile: +impo.toFixed(numDecimali),
        iva: +iva.toFixed(numDecimali),
      };
      valore.aliquotaIva = rp.aliquotaIva; // riga.aliquotaIva.codice
      valore.prezzoUnitario = +(valore.valore / valore.quantita).toFixed(
        numDecimali
      );
      valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(
        numDecimali
      );
      valore.prezzoNettoUnitario =
        aliquota !== 0
          ? +(valore.prezzoUnitario / (1 + aliquota / 100)).toFixed(numDecimali)
          : valore.prezzoUnitario;
      valore.prezzoNettoTotale = +(
        valore.prezzoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      // valore.prezzoNettoTotale = aliquota !== 0 ? +(valore.prezzoTotale / (1 + aliquota / 100)).toFixed(6) : valore.prezzoTotale
      valore.importoUnitario = +(valore.prezzo / valore.quantita).toFixed(
        numDecimali
      );
      valore.importoTotale = +(
        valore.importoUnitario * valore.quantita
      ).toFixed(numDecimali);
      //valore.importoTotale = valore.prezzo
      valore.importoNettoUnitario = +(
        valore.imponibile / valore.quantita
      ).toFixed(numDecimali);
      // valore.importoNettoTotale = valore.imponibile
      valore.importoNettoTotale = +(
        valore.importoNettoUnitario * valore.quantita
      ).toFixed(numDecimali);
      valore.item = { codice: riga.codice, descrizione: riga.descrizione };
      valore.listino = { codice: riga.listino };
      valore.omaggio = false; // Verificare se gestire
      const valoreC = { ...valore, ...rp };
      valori.push(valoreC);
    }
  }
  return valori;
}

/* function calcolaValoriDdt(ddt, repartiStatistica) {
  const rr = ddt.righe
  let aliquote = rr.map(x => _.omit(x.aliquotaIva, 'stampante'))
  let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))
  
  aliquote = _.uniqBy(aliquote, 'codice')
  const valori = []
  for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
    const qta = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.quantita) })
    const vl = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    
    let valore = {
      quantita: qta
    }
    valore.prezzoUnitario = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
    
    valore.prezzoNettoUnitario = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(numDecimali)

    valore = { ...valore, ...rp }
    valori.push(valore)
  }
  
  return valori
} */

function calcolaValoriDocumento(ddt, repartiStatistica) {
  const rr = ddt.righe.filter((x) => x.aliquotaIva);
  let aliquote = rr.map((x) => _.omit(x.aliquotaIva, "stampante"));
  // let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))
  aliquote = _.uniqBy(aliquote, "codice");
  const valori = [];
  //for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
  for (let al of aliquote.filter((x) => !_.isEmpty(x))) {
    // aliquote
    al.aliquota = al.valore;
    const qta = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.quantita || 0);
      }
    );
    const vl =
      _.sumBy(
        rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
        (el) => {
          return parseFloat(el.valore.prezzoTotale);
        }
      ) || 0;

    let valore = {
      quantita: qta,
    };
    valore.prezzoUnitario = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.prezzoUnitario);
      }
    );
    valore.prezzoTotale = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.prezzoTotale);
      }
    );
    // valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)

    valore.prezzoNettoUnitario = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.prezzoNettoUnitario);
      }
    );
    valore.prezzoNettoTotale = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.prezzoNettoTotale);
      }
    );
    // valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.importoUnitario);
      }
    );
    valore.importoTotale = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return parseFloat(el.valore.importoTotale);
      }
    );
    // valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)
    // valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return el.omaggio ? 0 : parseFloat(el.valore.importoNettoTotale);
      }
    );
    // TODO: Verificare: Devo comunque riportare l'importo sulla riga per la generazione dell'xml
    // valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoTotale) })
    valore.omaggi = _.sumBy(
      rr.filter((x) => x.aliquotaIva.codice === String(al.codice)),
      (el) => {
        return el.omaggio ? parseFloat(el.valore.importoNettoTotale) : 0;
      }
    );
    valore.iva = +(
      valore.importoTotale -
      valore.importoNettoTotale -
      valore.omaggi
    ).toFixed(numDecimali);
    // valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(
      numDecimali
    );

    valore = { ...valore, ...al };
    valori.push(valore);
  }

  return valori;
}

function calcolaDettaglioDdt(ddt, repartiStatistica) {
  const valori = [];
  for (let riga of ddt.righe.filter((x) => x.quantita)) {
    let valore = {
      quantita: +parseFloat(riga.quantita).toFixed(numDecimali),
    };
    valore.prezzoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(
      numDecimali
    ); // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(
      numDecimali
    );

    // valore.prezzoNettoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(numDecimali)
    valore.prezzoNettoUnitario = +parseFloat(
      riga.valore.prezzoNettoUnitario
    ).toFixed(numDecimali); // TODO: Verificare
    valore.prezzoNettoTotale = +(
      valore.prezzoNettoUnitario * valore.quantita
    ).toFixed(numDecimali);

    valore.importoUnitario = +parseFloat(riga.valore.importoUnitario).toFixed(
      numDecimali
    ); // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(
      numDecimali
    );

    valore.importoNettoUnitario = +parseFloat(
      riga.valore.importoNettoUnitario
    ).toFixed(numDecimali); // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = +(
      valore.importoNettoUnitario * valore.quantita
    ).toFixed(numDecimali);
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(
      numDecimali
    );
    valore.aliquotaIva = riga.aliquotaIva.codice;
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(
      numDecimali
    );
    valore.sconto1 = riga.valore.sconto1;
    valore.sconto2 = riga.valore.sconto2;
    valore.sconto3 = riga.valore.sconto3;
    valore.sconto4 = riga.valore.sconto4;
    valore.item = {
      codice: _.get(riga, "prodotto.codice", ""),
      descrizione: riga.descrizione,
    };
    valore.unitaMisura = riga.unitaMisura;
    valore.omaggio = riga.omaggio;
    valore.listino = riga.valore.listino;

    const reparto = riga.repartoFiscale;
    const rp = repartiStatistica.find(
      (x) => String(x.repartoFiscale) === reparto
    );
    valore = { ...valore, ...rp };
    valori.push(valore);
  }

  return valori;
}

export default {
  getTotaleProdotti,
  getScontiScontrino,
  getTotaleResi,
  calcolaTotaliAliquote,
  calcolaTotaliAliquote_v2,
  calcolaTotaliAliquoteSpese,
  calcolaValoriScontrino,
  calcolaDettaglioScontrino,
  calcolaScadenze,
  calcolaSpese,
  // calcolaValoriDdt,
  calcolaDettaglioDdt,
  calcolaValoriDocumento,
};
